import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleArrowPrev = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.8333 0.5L7.45233 5.881L12.8333 11.262M5.881 0.5L0.5 5.881L5.881 11.262",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDoubleArrowPrev;
